import * as React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../common/button/button";
import OrderStatus from "../my_orders/components/order_status";

interface OrderProps {
  order: {
    orderNumber: string;
    droneName: string;
    orderedBy: string;
    date: string;
    time: string;
    location: string;
    status: string;
    price: number;
  };
}

const DroneOrder: React.FC<OrderProps> = ({ order }) => {
  const navigate = useNavigate();

  const handleOrderDetails = () => {
    navigate(`/drone-order/${order.orderNumber}`, { state: { order } });
  };

  return (
    <div className="border border-[#BCBCBC] rounded-2xl mb-4">
      <div className="p-4 flex justify-between items-start">
        <div>
          <p className="font-ubuntu font-semibold">
            Order number {order.orderNumber} for {order.droneName}
          </p>
          <p className="font-ubuntu text-sm text-gray-600">
            Ordered by {order.orderedBy}
          </p>
          <p className="font-ubuntu text-sm">
            {order.date}, {order.time}
          </p>
          <p className="font-ubuntu text-sm flex items-center">
            <svg
              className="w-4 h-4 mr-1"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
              />
            </svg>
            {order.location}
          </p>
        </div>
        <OrderStatus status={order.status} />
      </div>
      <div className="font-ubuntu border-t border-[#BCBCBC] p-4 flex justify-between items-center">
        <p className="font-semibold">${order.price}</p>
        <Button buttonType="account" onClick={handleOrderDetails}>
          Order details
        </Button>
      </div>
    </div>
  );
};

export default DroneOrder;
